const NESTED_SCROLL_SELECTORS = [
  '#sticky-search',
  '#categories',
  '#sidebar',
  '#wizard-modal',
  '.document-preview-content',
  '.modal-body.scrolling.content'
]

const SCROLL_RETRY_DELAYS_MS = [0, 50, 150, 300]

function shouldPreserveFocus (el) {
  if (!el || !el.closest) return false
  return Boolean(
    el.closest('.modal-mask, .modal-container, .document-preview-public-page, .quote-signature-modal-mask')
  )
}

/** Browsers scroll the viewport when inputs retain focus across route changes (common on iOS Safari). */
function blurRouteFocus () {
  if (typeof document === 'undefined') return

  const active = document.activeElement
  if (!active || active === document.body || active === document.documentElement) return
  if (shouldPreserveFocus(active)) return

  try {
    if (typeof active.blur === 'function') {
      active.blur()
    }
  } catch (_) { /* ignore */ }
}

function applyScrollPosition (top, left) {
  if (typeof window === 'undefined' || typeof document === 'undefined') return

  document.body.classList.remove('no-scroll')

  const roots = [
    document.scrollingElement,
    document.documentElement,
    document.body,
    document.getElementById('app')
  ].filter(Boolean)

  roots.forEach((el) => {
    try {
      el.scrollTop = top
      el.scrollLeft = left
    } catch (_) { /* ignore */ }
  })

  try {
    window.scrollTo({ top, left, behavior: 'auto' })
  } catch (_) {
    window.scrollTo(left, top)
  }

  NESTED_SCROLL_SELECTORS.forEach((selector) => {
    document.querySelectorAll(selector).forEach((el) => {
      el.scrollTop = top
      el.scrollLeft = left
    })
  })
}

let scrollResetTimerIds = []

function clearScheduledScrollResets () {
  scrollResetTimerIds.forEach((id) => clearTimeout(id))
  scrollResetTimerIds = []
}

function runScrollReset (top, left) {
  blurRouteFocus()
  applyScrollPosition(top, left)
  requestAnimationFrame(() => {
    blurRouteFocus()
    applyScrollPosition(top, left)
  })
}

export function resetAppScroll (savedPosition) {
  clearScheduledScrollResets()

  if (savedPosition) {
    const top = savedPosition.y != null ? savedPosition.y : (savedPosition.top || 0)
    const left = savedPosition.x != null ? savedPosition.x : (savedPosition.left || 0)
    runScrollReset(top, left)
    return
  }

  runScrollReset(0, 0)
  SCROLL_RETRY_DELAYS_MS.forEach((delay) => {
    const id = setTimeout(() => runScrollReset(0, 0), delay)
    scrollResetTimerIds.push(id)
  })
}

export function initScrollRestoration () {
  if (typeof window !== 'undefined' && window.history && 'scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual'
  }
}
